<script>
  import { ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import { editPaymentSettings } from '../popups/PaymentSettings.svelte';
  import { showActivateAddonUI } from '../../Billing/Addons/addons';

  export let item,
    type = 'CIRCLE',
    onChange = ignore,
    isTemplate = false;

  let accessLevel = '';
  let chosenAccessLevelMemberGroups = [];
  let isLoggedInDisabled = External.Website.communityLimited;
  let isMembershipDisabled = External.Website.communityLimited || isTemplate;
  let isPaymentDisabled = External.Website.communityLimited || isTemplate;

  let refreshFlags = () => {
    External.Website.communityLimited = External.Website.communityLimited;
    isLoggedInDisabled = External.Website.communityLimited;
    isMembershipDisabled = External.Website.communityLimited || isTemplate;
    isPaymentDisabled = External.Website.communityLimited || isTemplate;
  };

  let onAccessChanged = () => {
    item.access = {
      ...item.access,
      type: accessLevel
    };

    if (accessLevel === 'PAID') {
      item.settings.requestAccess.enabled = false;
    }
    onChange();
  };

  let selectMemberGroups = () => {
    External.Tools.chooseMultiple({
      title: M.SELECT_MEMBER_GROUPS,
      message: '',
      noItemsMessage: M.NO_MEMBER_GROUPS,
      items: External.Website.memberGroups,
      selectedItems: chosenAccessLevelMemberGroups,
      getItemId: (group) => {
        return group.id;
      },
      getItemText: (group) => {
        return group.name;
      },
      isModal: true,
      onSelect: (groups) => {
        chosenAccessLevelMemberGroups = groups;
        item.access = {
          ...item.access,
          memberGroups: groups.map((g) => g.id)
        };
        onChange();
      }
    });
  };

  let showPaymentSettings = () => {
    editPaymentSettings(item, type, onChange);
  };

  let upgrade = async () => {
    await showActivateAddonUI('COMMUNITY', null, true, M.COMMUNITY_LIMITS_REACHED);
    setTimeout(refreshFlags, 1000);
  };

  onMount(() => {
    accessLevel = item.access?.type || (type === 'CIRCLE' ? 'OPEN' : 'INHERIT');
    if (isTemplate && (accessLevel === 'GROUP_MEMBER' || accessLevel === 'PAID')) {
      accessLevel = type === 'CIRCLE' ? 'OPEN' : 'INHERIT';
    }
    chosenAccessLevelMemberGroups = item.access?.memberGroups
      ? External.Website.memberGroups.filter((g) => item.access.memberGroups.includes(g.id))
      : [];
  });
</script>

<div class="info">
  <h5>{M.ACCESS_LEVEL}</h5>
</div>
<select class="page-select" bind:value={accessLevel} on:change={onAccessChanged}>
  {#if type !== 'CIRCLE'}
    <option value="INHERIT">{M.INHERIT}</option>
  {/if}
  <option value="OPEN">{M.OPEN}</option>
  <option value="LOGGED_IN" disabled={isLoggedInDisabled}>{M.LOGGED_IN_MEMBERS}</option>
  <option value="GROUP_MEMBER" disabled={isMembershipDisabled}>{M.MEMBERS_OF_GROUP}</option>
  <option value="PAID" disabled={isPaymentDisabled}>{M.PAYMENT_REQUIRED}</option>
</select>
{#if accessLevel === 'INHERIT'}
  <span class="explainer-text col20 f-left">{M.INHREIT_DESC}</span>
{:else if accessLevel === 'OPEN'}
  <span class="explainer-text col20 f-left">{M.OPEN_DESC}</span>
{:else if accessLevel === 'LOGGED_IN'}
  <span class="explainer-text col20 f-left">{M.LOGGEDIN_DESC}</span>
{:else if accessLevel === 'GROUP_MEMBER'}
  <span class="explainer-text col20 f-left">{M.MEMBERS_OF_GROUP_DESC}</span>
{:else if accessLevel === 'PAID'}
  <span class="explainer-text col20 f-left">{M.PAYMENT_REQUIRED_DESC}</span>
{/if}

{#if item.access?.type === 'GROUP_MEMBER'}
  <div class="col20 f-left gray-section product-select-wrapper mt-10">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.MEMBERS_GROUP}</h4>
      <a class="text-link blue-text" data-role="recurringSettings" on:click={selectMemberGroups}>{M.SELECT}</a>
      <!--<ul class="groups">
        {#each chosenAccessLevelMemberGroups as memberGroup}
          <li>{memberGroup.name}</li>
        {/each}
      </ul>-->
    </div>
  </div>
{/if}
{#if item.access?.type === 'PAID'}
  <a class="middle-button blue flex-none mt-10" on:click={showPaymentSettings}>{M.EDIT_PAYWALL_SETTINGS}</a>
{/if}

{#if External.Website.communityLimited}
  <a class="upgrade-box red-bg" on:click={upgrade}>
    <span>{@html M.COMMUNITY_UPGRADE_BOX}</span>
  </a>
{/if}
